import { Controller } from "@hotwired/stimulus"

// 値をクリップボードにコピーし、結果をボタンの横に短く表示する。
// NOTE: navigator.clipboard は https か localhost でしか使えない。ローカルの http://lvh.me:3000 では
//       「コピーできませんでした」になるので、localhost で開いて確かめること。
export default class extends Controller {
  static targets = ["notice"]
  static values = { text: String }

  disconnect() {
    clearTimeout(this.timeout)
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.textValue)
      this.notify("コピーしました")
    } catch {
      this.notify("コピーできませんでした")
    }
  }

  notify(message) {
    this.noticeTarget.textContent = message
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.noticeTarget.textContent = ""
    }, 2000)
  }
}
